module.exports = "<ion-app style='justify-content: normal'>\r\n  <router-outlet class='base-router'></router-outlet>\r\n</ion-app>"